class tickets {
	constructor(document) {
		this.doc = document;
		this.window = window;
		this.tabs = this.doc.querySelector('.tickets-tabs-nav');
		this.navButtons = this.tabs?.querySelectorAll('.tabs-nav__link');
		this.ticketsInner = this.doc.querySelector('.tabs-main__item');

		if (this.canInit()) {
			this.init();
		}
	}

	canInit = () => {
		if (this.navButtons) {
			return this.navButtons.length > 0 ? true : false;
		} return false;

	};

	init = () => {
		this.navButtons.forEach((button) => {
			button.addEventListener('click', () => {
				let active = this.tabs.querySelector('.tabs-nav__link.active');
				if (button !== active) {
					this.toggleActive([active, button]);
					this.changeUrl(button.dataset.url);
					this.xhr();
				}
			});
		});

		this.request = axios.create({
			baseURL: '/xhr/',
			withCredentials: false,
		});

		this.window.onpopstate = (e) => {
			if (e.state) {
				this.getURL();
				let active = this.tabs.querySelector('.tabs-nav__link.active');
				let button = this.tabs.querySelector(`[data-url='${this.requestUri}']`);
				this.toggleActive([active, button]);
				this.xhr();
			}
		};
	};

	toggleActive = (buttons) => {
		buttons.forEach((button) => {
			button.classList.toggle('active');
		});
	};

	getURL = () => {
		this.url = new URL(window.location);
		this.requestUri = this.url.pathname.split('/').pop();
	};

	changeUrl = (friendlyUrlName) => {
		this.getURL();
		window.history.pushState({}, '', `${this.url.origin}/tickets/${friendlyUrlName}`);
	};

	xhr = () => {
		this.getURL();
		this.request
			.post(`tickets.php`, this.requestUri)
			.then(({ data }) => {
				this.replaceView(data);
			})
			.catch((error) => {
				// handle error
				console.log(error);
			})
			.finally(() => {
				// always executed
				// console.log('finally');
			});
	};

	replaceView = (data) => {
		const tickets = data.snippet;
		this.ticketsInner.classList.add('is-invisible');
		setTimeout(() => {
			this.ticketsInner.innerHTML = tickets;
			this.ticketsInner.classList.remove('is-invisible');
		}, 400);
	};
}

new tickets(document);
